export function PreviewEmptyState() {
  return (
    <div className="flex-1 flex items-center justify-center p-12">
      <div className="text-center max-w-sm space-y-4">
        <div className="bg-muted rounded-full w-16 h-16 flex items-center justify-center mx-auto shadow-inner">
          <svg
            className="w-8 h-8 text-muted-foreground/50"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <div>
          <p className="text-base font-semibold text-foreground">No fields defined yet</p>
          <p className="text-sm text-muted-foreground mt-1">
            Switch back to the Build tab and drag some fields to get started.
          </p>
        </div>
      </div>
    </div>
  );
}
